<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <ProgressBar />
    <PageHeading :default-heading="pd_content.page_header" />
    <form @submit.prevent>
      <div class="pvd-container container-divider">
        <p>
          <VueShowdown
            :extensions="[formatMarkdown]"
            :markdown="pd_content.bodyContent.desc1"
          />
        </p>
        <p>
          <VueShowdown
            :extensions="[formatMarkdown]"
            :markdown="pd_content.bodyContent.desc2"
          />
        </p>
      </div>
      <div class="pvd-container">
        <p class="xsmall color-neutral">
          <VueShowdown
            :extensions="[formatMarkdown]"
            :markdown="pd_content.bodyContent.terms"
          />
        </p>
      </div>
      <NavigationComponent />
    </form>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import utility from '../mixins/utility';

export default {
  name: 'PromotionalIneligible',
  components: {
    NavigationComponent,
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, utility],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  mounted() {
    document.title = this.setTitle(this.pd_content.page_header);
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
    this.commitPrimaryUserData('', 'promotionalText');
    this.commitPrimaryUserData('', 'promotionalCode');
  },
};
</script>
